import { Container } from '@/components/Container'
import EditorTextParser from '@/components/EditorTextParser'
import Link from 'next/link'
import { useRouter } from 'next/router'

function ArrowLeftIcon(props) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path
        d="M7.25 11.25 3.75 8m0 0 3.5-3.25M3.75 8h8.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArticleLayout({ children, meta, isRssFeed = false, previousPathname }) {
  if (isRssFeed) {
    return children
  }

  const router = useRouter()
  var isMobileBackBtn = false
  if (router.query.ref) {
    if (router.query.ref === 'WEB') {
      isMobileBackBtn = true
    }
  }

  return (
    <>
      <Container className="mt-6 lg:mt-32">
        <div className="xl:relative">
          <div className="mx-auto max-w-2xl">
            <Link
              href={`/notice${router.query.ref ? `?ref=${router.query.ref}` : ''}`}
              aria-label="Go back to articles"
              className={`group mb-8 ${
                !isMobileBackBtn ? 'hidden' : ''
              } h-10 w-10 items-center justify-center rounded-full bg-white shadow-md shadow-zinc-800/5 ring-1 ring-zinc-900/5 transition lg:absolute lg:-left-5 lg:-mt-2 lg:mb-0 lg:flex xl:-top-1.5 xl:left-0 xl:mt-0`}
            >
              <ArrowLeftIcon className="h-4 w-4 stroke-zinc-500 transition group-hover:stroke-zinc-700" />
            </Link>
            {meta ? (
              <article>
                <header className="flex flex-col">
                  <h1 className="mt-3 text-2xl font-bold tracking-tight text-zinc-800 ">{meta.title}</h1>
                  <time dateTime={meta.createdAt} className="order-first flex items-center text-sm text-zinc-400">
                    <span className="h-4 w-0.5 rounded-full bg-zinc-200" />
                    <span className="ml-3">{meta.createdAt}(UTC)</span>
                  </time>
                </header>
                <hr className="mt-4" />
                <EditorTextParser data={meta.document} />
              </article>
            ) : (
              <div className="text-center">Not found notice.</div>
            )}
          </div>
        </div>
      </Container>
    </>
  )
}
